import React from 'react';
import PropTypes from 'prop-types';
import styles from './monitor.css';
import hourglass from './icon/hourglass.png';

const HourglassMonitor = ({categoryColor, label, value}) => (
    <div className={styles.themeMonitor}>
         <img src={hourglass} className={styles.themeMonitorIcon}/>
         <div className={styles.themeMonitorVbg}>
            <div className={styles.themeMonitorValue}>{value}</div>
         </div>
    </div>
);

HourglassMonitor.propTypes = {
    categoryColor: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ])
};

export default HourglassMonitor;
